module.exports = __webpack_public_path__ + "static/media/4.71a29f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格未选中态/4.png
// module id = 1268
// module chunks = 0